// Recipe book tag vocabulary helpers, shared by the list, the detail page and structured data.
//
// Recipes store tags as Persian names; filter URLs carry slugs. The vocabulary
// (GET /public/recipe-book/tags) maps between the two and says which group a tag belongs to.
// Filters follow the app's semantics: one tag per group, and several groups combine with AND
// (the API gets `tagMode=all` as soon as two tags are chosen), so «مرغ + رژیمی» means both.

// What the dish is made of first; the long cuisine list last.
export const TAG_GROUP_ORDER = ['ingredient', 'diet', 'method', 'cuisine'];

export const orderTagGroups = (groups = []) => [...groups]
    .filter((group) => group?.tags?.length)
    .sort((a, b) => {
        const rank = (group) => {
            const index = TAG_GROUP_ORDER.indexOf(group.id);
            return index === -1 ? TAG_GROUP_ORDER.length : index;
        };
        return rank(a) - rank(b);
    });

export const parseTagSlugs = (value) => [...new Set(String(value || '')
    .split(',')
    .map((slug) => slug.trim().toLowerCase())
    .filter(Boolean))];

export const serializeTagSlugs = (slugs = []) => parseTagSlugs(slugs.join(',')).join(',');

// Adds `tags` (and `tagMode=all` for two or more) to an API query.
export const applyTagQuery = (params, slugs) => {
    const list = parseTagSlugs(Array.isArray(slugs) ? slugs.join(',') : slugs);
    if (!list.length) return params;
    params.set('tags', list.join(','));
    if (list.length > 1) params.set('tagMode', 'all');
    return params;
};

// Picking a tag replaces any other tag of the same group; picking the selected one clears it.
export const toggleTagSlug = (selected, slug, groups = []) => {
    const current = parseTagSlugs(selected.join(','));
    if (current.includes(slug)) return current.filter((item) => item !== slug);
    const group = groups.find((item) => item.tags.some((tag) => tag.slug === slug));
    const siblings = new Set(group ? group.tags.map((tag) => tag.slug) : []);
    return [...current.filter((item) => !siblings.has(item)), slug];
};

export const tagSlugByName = (groups = []) => {
    const map = new Map();
    groups.forEach((group) => group.tags.forEach((tag) => map.set(tag.name, tag.slug)));
    return map;
};

export const tagNameBySlug = (groups = []) => {
    const map = new Map();
    groups.forEach((group) => group.tags.forEach((tag) => map.set(tag.slug, tag.name)));
    return map;
};

export const tagNamesInGroup = (groups = [], groupId) => new Set(
    (groups.find((group) => group.id === groupId)?.tags || []).map((tag) => tag.name),
);
